import { Navigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '@/store/authStore'
import { hrApi } from '@/services/api/hr'

export function HrWorkRedirect({ children }: { children: React.ReactNode }) {
  const role = useAuthStore(s => s.user?.role)
  const { data, isLoading } = useQuery({
    queryKey: ['hr-my-scopes'],
    queryFn: () => hrApi.getMyScopes(),
    staleTime: 5 * 60 * 1000,
    retry: false,
    enabled: role === 'hr',
  })

  if (role !== 'hr') return <>{children}</>
  if (isLoading) return <div className="p-6 text-gray-500">Laden...</div>
  if (data?.module_enabled !== true) return <Navigate to="/hr" replace />
  return <>{children}</>
}
